import { render, staticRenderFns } from "./PaymentSuccessMainPage.vue?vue&type=template&id=230dfc60&scoped=true&"
import script from "./PaymentSuccessMainPage.vue?vue&type=script&lang=js&"
export * from "./PaymentSuccessMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230dfc60",
  null
  
)

export default component.exports